import type { AxiosResponse } from "axios";
import { Response } from "interfaces/utils/utils.interface";
import httpService from "plugins/axios";
import { logService } from "./log.service";

class Services {
  public get(): Promise<AxiosResponse<Response>> {
    return httpService.get<Response>(`admin/career`);
  }
  public update(data: any): Promise<AxiosResponse<Response>> {
    logService.create("manage_career");
    const formData = new FormData();
    formData.append("careerFile", data.file);
    formData.append("titleTh", data.titleTh);
    formData.append("titleEn", data.titleEn);
    formData.append("detailTh", data.detailTh);
    formData.append("detailEn", data.detailEn);
    return httpService.put<Response>(`admin/career`, formData);
  }
  public updateActive(data: any): Promise<AxiosResponse<Response>> {
    logService.create("manage_career");
    return httpService.patch<Response>(`admin/career/active `, {
      isActive: data.isActive,
    });
  }
}

export const CareerService = new Services();
